import ExcelJS from 'exceljs';
import { classificationService } from '../services/classificationService';

/** Encabezados exactos (deben coincidir con la plantilla descargada) */
export const CAT_COL = {
  name: 'Nombre',
  desc: 'Descripción',
  active: 'Activo',
};

export const SUB_COL = {
  categoryRef: 'Categoría (código o nombre)',
  name: 'Nombre',
  desc: 'Descripción',
  active: 'Activo',
};

export const FAM_COL = {
  categoryRef: 'Categoría (código o nombre)',
  subcategoryRef: 'Subcategoría (código o nombre)',
  name: 'Nombre',
  desc: 'Descripción',
  active: 'Activo',
};

const HEADER_FILL = {
  type: 'pattern',
  pattern: 'solid',
  fgColor: { argb: 'FFD1FAE5' },
};

function downloadBuffer(buffer, filename) {
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

function styleHeaderRow(row, labels) {
  labels.forEach((label, i) => {
    const c = row.getCell(i + 1);
    c.value = label;
    c.font = { bold: true };
    c.fill = HEADER_FILL;
  });
}

export async function downloadCategoriesTemplate(opts = {}) {
  const suf = opts.filenameSuffix ? `_${opts.filenameSuffix}` : '';
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet('Categorías', { views: [{ state: 'frozen', ySplit: 2 }] });
  ws.mergeCells('A1:C1');
  ws.getCell('A1').value =
    'El código lo genera el sistema automáticamente. Fila 2 = encabezados. Datos desde fila 3. Columna Activo: Sí o No.';
  ws.getCell('A1').alignment = { wrapText: true, vertical: 'middle' };
  ws.getRow(1).height = 42;
  styleHeaderRow(ws.getRow(2), [CAT_COL.name, CAT_COL.desc, CAT_COL.active]);
  ws.columns = [{ width: 36 }, { width: 44 }, { width: 12 }];
  const buf = await wb.xlsx.writeBuffer();
  downloadBuffer(buf, `plantilla_importar_categorias${suf}.xlsx`);
}

export async function downloadSubcategoriesTemplate(opts = {}) {
  const suf = opts.filenameSuffix ? `_${opts.filenameSuffix}` : '';
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet('Subcategorías', { views: [{ state: 'frozen', ySplit: 2 }] });
  ws.mergeCells('A1:D1');
  ws.getCell('A1').value =
    'Indique la categoría padre por su código o nombre exacto (como en el sistema). El código de la subcategoría lo genera el sistema. Fila 2 = encabezados.';
  ws.getCell('A1').alignment = { wrapText: true, vertical: 'middle' };
  ws.getRow(1).height = 48;
  styleHeaderRow(ws.getRow(2), [
    SUB_COL.categoryRef,
    SUB_COL.name,
    SUB_COL.desc,
    SUB_COL.active,
  ]);
  ws.columns = [{ width: 34 }, { width: 32 }, { width: 40 }, { width: 12 }];
  const buf = await wb.xlsx.writeBuffer();
  downloadBuffer(buf, `plantilla_importar_subcategorias${suf}.xlsx`);
}

export async function downloadFamiliesTemplate(opts = {}) {
  const suf = opts.filenameSuffix ? `_${opts.filenameSuffix}` : '';
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet('Familias', { views: [{ state: 'frozen', ySplit: 2 }] });
  ws.mergeCells('A1:E1');
  ws.getCell('A1').value =
    'Indique categoría y subcategoría por código o nombre. La subcategoría debe pertenecer a esa categoría. El código de la familia lo genera el sistema. Fila 2 = encabezados.';
  ws.getCell('A1').alignment = { wrapText: true, vertical: 'middle' };
  ws.getRow(1).height = 52;
  styleHeaderRow(ws.getRow(2), [
    FAM_COL.categoryRef,
    FAM_COL.subcategoryRef,
    FAM_COL.name,
    FAM_COL.desc,
    FAM_COL.active,
  ]);
  ws.columns = [{ width: 30 }, { width: 30 }, { width: 32 }, { width: 36 }, { width: 12 }];
  const buf = await wb.xlsx.writeBuffer();
  downloadBuffer(buf, `plantilla_importar_familias${suf}.xlsx`);
}

function activeLabel(isActive) {
  return isActive !== false && isActive !== 0 ? 'Sí' : 'No';
}

function categoryRefForRow(categories, categoryId) {
  const cat = categories.find(
    (c) => String(c.id) === String(categoryId) || String(c.receta_category_id) === String(categoryId)
  );
  if (!cat) return '';
  return cat.code || cat.name || '';
}

function subcategoryRefForRow(subcategories, subcategoryId) {
  const sub = subcategories.find(
    (s) => String(s.id) === String(subcategoryId) || String(s.receta_subcategory_id) === String(subcategoryId)
  );
  if (!sub) return '';
  return sub.code || sub.name || '';
}

export async function exportCategoriesToExcel(categories, opts = {}) {
  const suf = opts.filenameSuffix ? `_${opts.filenameSuffix}` : '';
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet('Categorías', { views: [{ state: 'frozen', ySplit: 2 }] });
  ws.mergeCells('A1:D1');
  ws.getCell('A1').value =
    'Exportación de categorías. Formato compatible con importación (datos desde fila 3). El código es referencia.';
  ws.getCell('A1').alignment = { wrapText: true, vertical: 'middle' };
  ws.getRow(1).height = 36;
  styleHeaderRow(ws.getRow(2), ['Código', CAT_COL.name, CAT_COL.desc, CAT_COL.active]);
  ws.columns = [{ width: 14 }, { width: 36 }, { width: 44 }, { width: 12 }];
  (categories || []).forEach((cat, index) => {
    const row = ws.getRow(3 + index);
    row.getCell(1).value = cat.code || '';
    row.getCell(2).value = cat.name || '';
    row.getCell(3).value = cat.description || '';
    row.getCell(4).value = activeLabel(cat.is_active);
  });
  const buf = await wb.xlsx.writeBuffer();
  downloadBuffer(buf, `categorias${suf}_${new Date().toISOString().slice(0, 10)}.xlsx`);
}

export async function exportSubcategoriesToExcel(subcategories, categories, opts = {}) {
  const suf = opts.filenameSuffix ? `_${opts.filenameSuffix}` : '';
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet('Subcategorías', { views: [{ state: 'frozen', ySplit: 2 }] });
  ws.mergeCells('A1:E1');
  ws.getCell('A1').value =
    'Exportación de subcategorías. Use código o nombre de categoría padre como en el sistema.';
  ws.getCell('A1').alignment = { wrapText: true, vertical: 'middle' };
  ws.getRow(1).height = 36;
  styleHeaderRow(ws.getRow(2), [
    SUB_COL.categoryRef,
    'Código',
    SUB_COL.name,
    SUB_COL.desc,
    SUB_COL.active,
  ]);
  ws.columns = [{ width: 34 }, { width: 14 }, { width: 32 }, { width: 40 }, { width: 12 }];
  (subcategories || []).forEach((sub, index) => {
    const row = ws.getRow(3 + index);
    const categoryId = sub.receta_category_id ?? sub.category_id;
    row.getCell(1).value = categoryRefForRow(categories || [], categoryId) || sub.category?.code || sub.category?.name || '';
    row.getCell(2).value = sub.code || '';
    row.getCell(3).value = sub.name || '';
    row.getCell(4).value = sub.description || '';
    row.getCell(5).value = activeLabel(sub.is_active);
  });
  const buf = await wb.xlsx.writeBuffer();
  downloadBuffer(buf, `subcategorias${suf}_${new Date().toISOString().slice(0, 10)}.xlsx`);
}

export async function exportFamiliesToExcel(families, categories, subcategories, opts = {}) {
  const suf = opts.filenameSuffix ? `_${opts.filenameSuffix}` : '';
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet('Familias', { views: [{ state: 'frozen', ySplit: 2 }] });
  ws.mergeCells('A1:F1');
  ws.getCell('A1').value =
    'Exportación de familias. Indique categoría y subcategoría padre como en el sistema.';
  ws.getCell('A1').alignment = { wrapText: true, vertical: 'middle' };
  ws.getRow(1).height = 36;
  styleHeaderRow(ws.getRow(2), [
    FAM_COL.categoryRef,
    FAM_COL.subcategoryRef,
    'Código',
    FAM_COL.name,
    FAM_COL.desc,
    FAM_COL.active,
  ]);
  ws.columns = [{ width: 30 }, { width: 30 }, { width: 14 }, { width: 32 }, { width: 36 }, { width: 12 }];
  (families || []).forEach((fam, index) => {
    const row = ws.getRow(3 + index);
    const sub = fam.subcategory || (subcategories || []).find((s) => String(s.id) === String(fam.receta_subcategory_id ?? fam.subcategory_id));
    const categoryId = sub?.receta_category_id ?? sub?.category_id ?? fam.subcategory?.receta_category_id;
    row.getCell(1).value =
      categoryRefForRow(categories || [], categoryId) ||
      fam.subcategory?.category?.code ||
      fam.subcategory?.category?.name ||
      '';
    row.getCell(2).value = subcategoryRefForRow(subcategories || [], sub?.id ?? fam.receta_subcategory_id ?? fam.subcategory_id) || sub?.code || sub?.name || '';
    row.getCell(3).value = fam.code || '';
    row.getCell(4).value = fam.name || '';
    row.getCell(5).value = fam.description || '';
    row.getCell(6).value = activeLabel(fam.is_active);
  });
  const buf = await wb.xlsx.writeBuffer();
  downloadBuffer(buf, `familias${suf}_${new Date().toISOString().slice(0, 10)}.xlsx`);
}

export function cellText(cell) {
  if (!cell || cell.value == null || cell.value === '') return '';
  const v = cell.value;
  if (typeof v === 'object' && v.richText) {
    return v.richText.map((x) => x.text).join('').trim();
  }
  if (typeof v === 'object' && v.text != null) return String(v.text).trim();
  if (v instanceof Date) return v.toISOString();
  return String(v).trim();
}

export function parseActiveCell(raw) {
  if (raw == null || raw === '') return true;
  const s = String(raw).trim().toLowerCase();
  if (['no', 'n', '0', 'false', 'falso', 'inactivo'].includes(s)) return false;
  if (['sí', 'si', 's', 'yes', 'y', '1', 'true', 'verdadero', 'activo'].includes(s)) return true;
  return true;
}

function headerMapFromRow(row) {
  const map = {};
  row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
    const t = cellText(cell);
    if (t) map[t] = colNumber;
  });
  return map;
}

function findHeaderRow(sheet, requiredLabels) {
  const maxScan = Math.min(30, sheet.rowCount || 30);
  for (let r = 1; r <= maxScan; r++) {
    const row = sheet.getRow(r);
    const map = headerMapFromRow(row);
    if (requiredLabels.every((label) => map[label] != null)) {
      return { rowIndex: r, colMap: map };
    }
  }
  return null;
}

function getLastUsedRow(sheet) {
  let last = 0;
  sheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
    if (rowNumber > last) last = rowNumber;
  });
  return last;
}

function formatApiError(err) {
  const d = err.response?.data;
  if (!d) return err.message || 'Error desconocido';
  if (d.message) return d.message;
  if (d.errors) {
    return Object.values(d.errors)
      .flat()
      .join('; ');
  }
  return 'Error al guardar';
}

function findCategoryByRef(categories, ref) {
  const q = String(ref).trim();
  if (!q) return null;
  const lower = q.toLowerCase();
  let c = categories.find((x) => String(x.code).toLowerCase() === lower);
  if (c) return c;
  c = categories.find((x) => String(x.name).trim().toLowerCase() === lower);
  return c || null;
}

function findSubcategoryByRef(subcategories, categoryId, ref) {
  const q = String(ref).trim();
  if (!q) return null;
  const lower = q.toLowerCase();
  const pool = subcategories.filter(
    (s) =>
      Number(s.category_id) === Number(categoryId) ||
      Number(s.receta_category_id) === Number(categoryId)
  );
  let s = pool.find((x) => String(x.code).toLowerCase() === lower);
  if (s) return s;
  s = pool.find((x) => String(x.name).trim().toLowerCase() === lower);
  return s || null;
}

async function loadFirstSheet(file) {
  const buf = await file.arrayBuffer();
  const wb = new ExcelJS.Workbook();
  await wb.xlsx.load(buf);
  return wb.worksheets[0] || null;
}

/**
 * Vista previa de categorías (sin guardar).
 * @returns {Promise<{ success: false, fatalMessage: string } | { success: true, previewRows, validTasks, validCount, emptyCount, invalidCount }>}
 */
export async function analyzeCategoriesImport(file) {
  const sheet = await loadFirstSheet(file);
  if (!sheet) {
    return { success: false, fatalMessage: 'El archivo no tiene hojas.' };
  }

  const found = findHeaderRow(sheet, [CAT_COL.name]);
  if (!found) {
    return {
      success: false,
      fatalMessage: `No se encontró la fila de encabezados con la columna "${CAT_COL.name}".`,
    };
  }

  const { rowIndex: headerRow, colMap } = found;
  const last = getLastUsedRow(sheet);
  const previewRows = [];
  const validTasks = [];

  for (let r = headerRow + 1; r <= last; r++) {
    const row = sheet.getRow(r);
    const name = cellText(row.getCell(colMap[CAT_COL.name]));
    const description = colMap[CAT_COL.desc] ? cellText(row.getCell(colMap[CAT_COL.desc])) : '';
    const activeRaw = colMap[CAT_COL.active] ? cellText(row.getCell(colMap[CAT_COL.active])) : '';
    const is_active = colMap[CAT_COL.active] ? parseActiveCell(cellText(row.getCell(colMap[CAT_COL.active]))) : true;

    if (!name) {
      previewRows.push({
        excelRow: r,
        status: 'empty',
        cols: { nombre: '', descripcion: description, activo: activeRaw },
        issue: '',
      });
      continue;
    }

    previewRows.push({
      excelRow: r,
      status: 'valid',
      cols: { nombre: name, descripcion: description, activo: is_active ? 'Sí' : 'No' },
      issue: '',
    });
    validTasks.push({
      excelRow: r,
      payload: { name: name.slice(0, 100), description: description || null, is_active },
    });
  }

  return {
    success: true,
    previewRows,
    validTasks,
    validCount: validTasks.length,
    emptyCount: previewRows.filter((x) => x.status === 'empty').length,
    invalidCount: previewRows.filter((x) => x.status === 'invalid').length,
  };
}

export async function executeCategoriesImport(validTasks, svc = classificationService) {
  const result = { created: 0, skipped: 0, errors: [] };
  for (const { excelRow, payload } of validTasks) {
    try {
      const res = await svc.createCategory(payload);
      if (res.success) result.created += 1;
      else {
        const msg =
          res.errors && typeof res.errors === 'object'
            ? Object.values(res.errors).flat().join('; ')
            : res.message || 'Respuesta sin éxito';
        result.errors.push({ row: excelRow, message: msg });
      }
    } catch (e) {
      result.errors.push({ row: excelRow, message: formatApiError(e) });
    }
  }
  return result;
}

/**
 * @param {File} file
 * @returns {Promise<{ created: number, skipped: number, errors: { row: number, message: string }[] }>}
 */
export async function importCategoriesFromExcel(file) {
  const analysis = await analyzeCategoriesImport(file);
  if (!analysis.success) {
    return { created: 0, skipped: 0, errors: [{ row: 0, message: analysis.fatalMessage }] };
  }
  const exec = await executeCategoriesImport(analysis.validTasks, classificationService);
  return { ...exec, skipped: analysis.emptyCount };
}

export async function analyzeSubcategoriesImport(file, svc = classificationService) {
  const sheet = await loadFirstSheet(file);
  if (!sheet) {
    return { success: false, fatalMessage: 'El archivo no tiene hojas.' };
  }

  const found = findHeaderRow(sheet, [SUB_COL.categoryRef, SUB_COL.name]);
  if (!found) {
    return {
      success: false,
      fatalMessage: `No se encontró encabezados con "${SUB_COL.categoryRef}" y "${SUB_COL.name}".`,
    };
  }

  const catRes = await svc.getCategories({ active_only: false });
  if (!catRes.success || !catRes.data) {
    return { success: false, fatalMessage: 'No se pudieron cargar las categorías.' };
  }
  const categories = catRes.data;

  const { rowIndex: headerRow, colMap } = found;
  const last = getLastUsedRow(sheet);
  const previewRows = [];
  const validTasks = [];

  for (let r = headerRow + 1; r <= last; r++) {
    const row = sheet.getRow(r);
    const catRef = cellText(row.getCell(colMap[SUB_COL.categoryRef]));
    const name = cellText(row.getCell(colMap[SUB_COL.name]));
    const description = colMap[SUB_COL.desc] ? cellText(row.getCell(colMap[SUB_COL.desc])) : '';
    const activeRaw = colMap[SUB_COL.active] ? cellText(row.getCell(colMap[SUB_COL.active])) : '';
    const is_active = colMap[SUB_COL.active] ? parseActiveCell(cellText(row.getCell(colMap[SUB_COL.active]))) : true;

    if (!catRef && !name) {
      previewRows.push({
        excelRow: r,
        status: 'empty',
        cols: { categoria: '', nombre: '', descripcion: description, activo: activeRaw },
        issue: '',
      });
      continue;
    }

    if (!catRef || !name) {
      previewRows.push({
        excelRow: r,
        status: 'invalid',
        cols: { categoria: catRef, nombre: name, descripcion: description, activo: activeRaw || (is_active ? 'Sí' : 'No') },
        issue: 'Indique categoría padre y nombre de subcategoría.',
      });
      continue;
    }

    const category = findCategoryByRef(categories, catRef);
    if (!category) {
      previewRows.push({
        excelRow: r,
        status: 'invalid',
        cols: { categoria: catRef, nombre: name, descripcion: description, activo: is_active ? 'Sí' : 'No' },
        issue: `Categoría no encontrada: "${catRef}".`,
      });
      continue;
    }

    previewRows.push({
      excelRow: r,
      status: 'valid',
      cols: {
        categoria: `${category.code} — ${category.name}`,
        nombre: name,
        descripcion: description,
        activo: is_active ? 'Sí' : 'No',
      },
      issue: '',
    });
    validTasks.push({
      excelRow: r,
      payload: {
        category_id: category.id,
        name: name.slice(0, 100),
        description: description || null,
        is_active,
      },
    });
  }

  return {
    success: true,
    previewRows,
    validTasks,
    validCount: validTasks.length,
    emptyCount: previewRows.filter((x) => x.status === 'empty').length,
    invalidCount: previewRows.filter((x) => x.status === 'invalid').length,
  };
}

export async function executeSubcategoriesImport(validTasks, svc = classificationService) {
  const result = { created: 0, skipped: 0, errors: [] };
  for (const { excelRow, payload } of validTasks) {
    try {
      const res = await svc.createSubcategory(payload);
      if (res.success) result.created += 1;
      else {
        const msg =
          res.errors && typeof res.errors === 'object'
            ? Object.values(res.errors).flat().join('; ')
            : res.message || 'Respuesta sin éxito';
        result.errors.push({ row: excelRow, message: msg });
      }
    } catch (e) {
      result.errors.push({ row: excelRow, message: formatApiError(e) });
    }
  }
  return result;
}

export async function importSubcategoriesFromExcel(file) {
  const analysis = await analyzeSubcategoriesImport(file);
  if (!analysis.success) {
    return { created: 0, skipped: 0, errors: [{ row: 0, message: analysis.fatalMessage }] };
  }
  const exec = await executeSubcategoriesImport(analysis.validTasks, classificationService);
  return { ...exec, skipped: analysis.emptyCount };
}

export async function analyzeFamiliesImport(file, svc = classificationService) {
  const sheet = await loadFirstSheet(file);
  if (!sheet) {
    return { success: false, fatalMessage: 'El archivo no tiene hojas.' };
  }

  const found = findHeaderRow(sheet, [FAM_COL.categoryRef, FAM_COL.subcategoryRef, FAM_COL.name]);
  if (!found) {
    return {
      success: false,
      fatalMessage: `No se encontró encabezados con "${FAM_COL.categoryRef}", "${FAM_COL.subcategoryRef}" y "${FAM_COL.name}".`,
    };
  }

  const [catRes, subRes] = await Promise.all([
    svc.getCategories({ active_only: false }),
    svc.getSubcategories({ active_only: false }),
  ]);
  if (!catRes.success || !catRes.data) {
    return { success: false, fatalMessage: 'No se pudieron cargar las categorías.' };
  }
  if (!subRes.success || !subRes.data) {
    return { success: false, fatalMessage: 'No se pudieron cargar las subcategorías.' };
  }
  const categories = catRes.data;
  const subcategories = subRes.data;

  const { rowIndex: headerRow, colMap } = found;
  const last = getLastUsedRow(sheet);
  const previewRows = [];
  const validTasks = [];

  for (let r = headerRow + 1; r <= last; r++) {
    const row = sheet.getRow(r);
    const catRef = cellText(row.getCell(colMap[FAM_COL.categoryRef]));
    const subRef = cellText(row.getCell(colMap[FAM_COL.subcategoryRef]));
    const name = cellText(row.getCell(colMap[FAM_COL.name]));
    const description = colMap[FAM_COL.desc] ? cellText(row.getCell(colMap[FAM_COL.desc])) : '';
    const activeRaw = colMap[FAM_COL.active] ? cellText(row.getCell(colMap[FAM_COL.active])) : '';
    const is_active = colMap[FAM_COL.active] ? parseActiveCell(cellText(row.getCell(colMap[FAM_COL.active]))) : true;

    if (!catRef && !subRef && !name) {
      previewRows.push({
        excelRow: r,
        status: 'empty',
        cols: { categoria: '', subcategoria: '', nombre: '', descripcion: description, activo: activeRaw },
        issue: '',
      });
      continue;
    }

    if (!catRef || !subRef || !name) {
      previewRows.push({
        excelRow: r,
        status: 'invalid',
        cols: {
          categoria: catRef,
          subcategoria: subRef,
          nombre: name,
          descripcion: description,
          activo: activeRaw || (is_active ? 'Sí' : 'No'),
        },
        issue: 'Indique categoría, subcategoría y nombre de familia.',
      });
      continue;
    }

    const category = findCategoryByRef(categories, catRef);
    if (!category) {
      previewRows.push({
        excelRow: r,
        status: 'invalid',
        cols: {
          categoria: catRef,
          subcategoria: subRef,
          nombre: name,
          descripcion: description,
          activo: is_active ? 'Sí' : 'No',
        },
        issue: `Categoría no encontrada: "${catRef}".`,
      });
      continue;
    }

    const subcategory = findSubcategoryByRef(subcategories, category.id, subRef);
    if (!subcategory) {
      previewRows.push({
        excelRow: r,
        status: 'invalid',
        cols: {
          categoria: `${category.code} — ${category.name}`,
          subcategoria: subRef,
          nombre: name,
          descripcion: description,
          activo: is_active ? 'Sí' : 'No',
        },
        issue: `Subcategoría no encontrada en esa categoría: "${subRef}".`,
      });
      continue;
    }

    previewRows.push({
      excelRow: r,
      status: 'valid',
      cols: {
        categoria: `${category.code} — ${category.name}`,
        subcategoria: `${subcategory.code} — ${subcategory.name}`,
        nombre: name,
        descripcion: description,
        activo: is_active ? 'Sí' : 'No',
      },
      issue: '',
    });
    validTasks.push({
      excelRow: r,
      payload: {
        subcategory_id: subcategory.id,
        name: name.slice(0, 100),
        description: description || null,
        is_active,
      },
    });
  }

  return {
    success: true,
    previewRows,
    validTasks,
    validCount: validTasks.length,
    emptyCount: previewRows.filter((x) => x.status === 'empty').length,
    invalidCount: previewRows.filter((x) => x.status === 'invalid').length,
  };
}

export async function executeFamiliesImport(validTasks, svc = classificationService) {
  const result = { created: 0, skipped: 0, errors: [] };
  for (const { excelRow, payload } of validTasks) {
    try {
      const res = await svc.createFamily(payload);
      if (res.success) result.created += 1;
      else {
        const msg =
          res.errors && typeof res.errors === 'object'
            ? Object.values(res.errors).flat().join('; ')
            : res.message || 'Respuesta sin éxito';
        result.errors.push({ row: excelRow, message: msg });
      }
    } catch (e) {
      result.errors.push({ row: excelRow, message: formatApiError(e) });
    }
  }
  return result;
}

export async function importFamiliesFromExcel(file) {
  const analysis = await analyzeFamiliesImport(file);
  if (!analysis.success) {
    return { created: 0, skipped: 0, errors: [{ row: 0, message: analysis.fatalMessage }] };
  }
  const exec = await executeFamiliesImport(analysis.validTasks, classificationService);
  return { ...exec, skipped: analysis.emptyCount };
}

export function summarizeImportResult(result) {
  const { created, skipped, errors } = result;
  const parts = [`Registros creados: ${created}.`];
  if (skipped > 0) parts.push(`Filas vacías omitidas: ${skipped}.`);
  if (errors.length > 0) {
    const preview = errors
      .slice(0, 5)
      .map((e) => (e.row ? `Fila ${e.row}: ${e.message}` : e.message))
      .join(' ');
    parts.push(`Errores: ${errors.length}. ${preview}${errors.length > 5 ? '…' : ''}`);
  }
  return parts.join(' ');
}
